export default __webpack_public_path__ + "static/media/logo-green.edbe966c.svg";